import React from "react";
import PropTypes from "prop-types";
import Avatar from "react-avatar";
import Button from "components/Button";
import "./index.scss";

const CollaboratorsCell = ({ value, row, sendInvite }) => {
  const renderCollaborator = () => {
    if (!value.length) return <div>No Collaborator</div>;

    return (
      <>
        {value.slice(0, 3).map((collaborator) => (
          <Avatar
            name={collaborator.email}
            className="avatar"
            round
            size="28"
            key={collaborator.email}
          />
        ))}
        {value.length > 3 && (
          <div className="additional">+{value.length - 3}</div>
        )}
      </>
    );
  };

  return (
    <div data-testid="collaborators" className="farm-collaborators-cell">
      <div className={row.isExpanded ? "cell-header" : "cell-header -hidden"}>
        Collaborators
      </div>
      <div className="avatar-wrapper">{renderCollaborator()}</div>
      <Button
        type="outlined"
        size="small"
        label="Share"
        color="white"
        onClick={() => sendInvite(row.original.properties)}
      />
    </div>
  );
};

CollaboratorsCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object).isRequired,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  sendInvite: PropTypes.func.isRequired,
};

export default CollaboratorsCell;
